import PropTypes from 'prop-types'

// Shapes PropTypes des objets RPQS renvoyés par le back (pas de classe DTO : un décalage
// de champ ne provoque qu'un warning, jamais un plantage).

// Indicateur complet renvoyé par GET /rpqs/indicators (référentiel + valeur + valeur N-1 + suivi).
export const rpqsIndicatorShape = PropTypes.shape({
    // category : 1=Abonné, 2=Réseau, 3=Qualité, 4=Gestion financière
    category: PropTypes.number,
    code: PropTypes.string,
    name: PropTypes.string,
    mainName: PropTypes.string,
    // parent absent/null = indicateur principal
    parent: PropTypes.string,
    order: PropTypes.number,
    unit: PropTypes.string,
    comment: PropTypes.string,
    formula: PropTypes.string,
    proposedFormula: PropTypes.string,
    fieldType: PropTypes.string,
    readOnly: PropTypes.bool,
    // mandatory : 'true' / 'false' / formule conditionnelle
    mandatory: PropTypes.string,
    // value : JSON (multi-typage)
    value: PropTypes.string,
    previousValue: PropTypes.string,
    notes: PropTypes.string,
    // status : code back (0 incomplet, 1 en cours, 2 en attente, 3 validé)
    status: PropTypes.number,
    updateLogin: PropTypes.string,
    updateDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    // valeur saisie à la main sur un indicateur à formule (ne pas la recalculer)
    manualInput: PropTypes.bool,
})

// RPQS : identifié par (year, collectivityId).
export const rpqsShape = PropTypes.shape({
    year: PropTypes.number,
    collectivityId: PropTypes.number,
    name: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    updateLogin: PropTypes.string,
    updateDate: PropTypes.number,
    notes: PropTypes.string,
})

// Événement d'un RPQS (year renseigné, sans managementUnitId = RPQS global) ou du référentiel
// (sans year : collectivityId seul = collectivité, managementUnitId = entité de gestion).
// origin ('rpqs' / 'referential') est ajouté côté front quand les deux sont mélangés.
export const rpqsEventShape = PropTypes.shape({
    origin: PropTypes.string,
    year: PropTypes.number,
    collectivityId: PropTypes.number,
    managementUnitId: PropTypes.number,
    number: PropTypes.number,
    date: PropTypes.number,
    hour: PropTypes.number,
    comment: PropTypes.string,
    contactCode: PropTypes.number,
    eventType: PropTypes.string,
    updateLogin: PropTypes.string,
    updateDate: PropTypes.number,
})

// Fichier renvoyé par files/system/listFiles.
export const rpqsDocumentShape = PropTypes.shape({
    url: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.number,
    updateDate: PropTypes.number,
})

// Réponse complète de GET /rpqs/indicators : la liste + les % d'avancement par catégorie.
export const rpqsIndicatorsResultShape = PropTypes.shape({
    indicators: PropTypes.arrayOf(rpqsIndicatorShape),
    progressSubscriber: PropTypes.number,
    progressNetwork: PropTypes.number,
    progressQuality: PropTypes.number,
    progressFinancial: PropTypes.number,
})